import React, { Component } from "react";
import './revision-experience.scss';
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";
import CommonApi from "../../../apis/common";
import LayoutShared from "../../common/layout-shared/layout-shared";
import Loading from "../../common/loading/loading";
import { getImageSource } from "../../../utility/image-source";
import { ImageConstants } from "../../../constants/constants";
import { CountdownCircleTimer } from 'react-countdown-circle-timer'

// pdfjsLib.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.js";

const workerPath = window.location.pathname.replace(/\/[^/]*$/, "/pdf.worker.min.js");

pdfjsLib.GlobalWorkerOptions.workerSrc = workerPath;

class ClickerRevisionExperience extends Component {

    constructor(props) {
        super(props);

        this.state = {
            pdf: null,
            pageNumber: 1,
            numPages: 0,
            isLoading: false,
            studentList: this.props.studentList ? this.props.studentList : [],
            allowKey: false,
            restartKey : 0
        };

        this.canvasRef = React.createRef();
        this.containerRef = React.createRef();
        this.layoutShared = LayoutShared.getLayout()
    }

    componentDidMount() {
        this.getSignedUrl();

        window.addEventListener("resize", this.handleResize);

        if (window.AndroidClicker) {
            this.startScanning()

            if (window.AndroidClicker && window.AndroidClicker.getBluetoothStatus) {
                this.intervalForBLE = setInterval(() => {
                    this.checkBLEStatus()
                }, 0.5 * 60 * 1000);
            }
        }

        this.handleStartListening()
    }


    checkBLEStatus() {
        const statusJson = window.AndroidClicker.getBluetoothStatus();
        const status = JSON.parse(statusJson);
        //console.log("Bluetooth status:", status);

        // Example: show on UI
        if (!status.receivingSignal) {
            // alert("Bluetooth not receiving signal!");
            console.log('No Bluetooth Signal received.........')
        }
    }

    startScanning = () => {
        if (window.AndroidClicker) {
            console.log('scanning Started.......from Classwork experience')
            window.AndroidClicker.startScanning(); // Calls native Android function
        } else {
            //console.log("AndroidClicker interface not found!");
        }
    };




    handleResize = () => {

        const { pdf, pageNumber } = this.state;

        if (pdf) {
            this.renderPage(pdf, pageNumber);
        }

    };

    getSignedUrl() {

        const payload = {
            fileName:
                this.props.conceptCardPdf
        };

        this.setState({ isLoading: true })

        CommonApi.getSignedUrlForCheatSheet(payload)
            .then(response => {

                const signedUrl = response.data.signedUrl;

                this.loadPdf(signedUrl);

            })
            .catch(error => {
                console.log(error);
            });
    }

    loadPdf = async (pdfUrl) => {

        try {

            const loadingTask = pdfjsLib.getDocument({
                url: pdfUrl
            });

            const pdf = await loadingTask.promise;

            this.setState(
                {
                    pdf: pdf,
                    numPages: pdf.numPages
                },
                () => {
                    this.setState({ isLoading: false })
                    this.renderPage(pdf, 1);
                }
            );

        } catch (err) {
            console.error("PDF load error", err);
        }

    };

    renderPage = async (pdf, pageNumber) => {

        if (!pdf) return;

        const page = await pdf.getPage(pageNumber);

        const containerWidth = this.containerRef.current.offsetWidth;

        const viewport = page.getViewport({ scale: 1 });

        const scale = containerWidth / viewport.width;

        const scaledViewport = page.getViewport({ scale });

        const canvas = this.canvasRef.current;
        const context = canvas.getContext("2d");

        const outputScale = window.devicePixelRatio || 1;

        canvas.width = Math.floor(scaledViewport.width * outputScale);
        canvas.height = Math.floor(scaledViewport.height * outputScale);

        canvas.style.width = Math.floor(scaledViewport.width) + "px";
        canvas.style.height = Math.floor(scaledViewport.height) + "px";

        context.setTransform(outputScale, 0, 0, outputScale, 0, 0);

        await page.render({
            canvasContext: context,
            viewport: scaledViewport
        }).promise;

    };

    nextPage = () => {

        this.setState({ restartKey: this.state.restartKey + 1, allowKey: false })

        const { pageNumber, pdf, numPages } = this.state;

        if (pageNumber >= numPages) return;

        const newPage = pageNumber + 1;

        this.setState({ pageNumber: newPage });

        this.renderPage(pdf, newPage);

    };

    prevPage = () => {

        this.setState({ restartKey: this.state.restartKey + 1, allowKey: false })

        const { pageNumber, pdf } = this.state;

        if (pageNumber <= 1) return;

        const newPage = pageNumber - 1;

        this.setState({ pageNumber: newPage });

        this.renderPage(pdf, newPage);

    };

    toggleLayoutBar() {
        // console.log('toggle called')
        // this.setState({hideLayoutSideBar : !this.state.hideLayoutSideBar}, () => {
        this.layoutShared.showHideLayoutBar(!this.layoutShared.state.showLayoutBar)
        // this.layoutShared.toggleSidebar(this.state.hideLayoutSideBar)
        // })

    }

    stopScanning = () => {
        if (window.AndroidClicker) {
            console.log('scanning Stoped.......')
            window.AndroidClicker.stopScanning(); // Calls native Android function
        } else {
            console.log("AndroidClicker interface not found!");
        }
    };

    allowKeyPress() {
        this.setState({ allowKey: true })
    }

    getTimer() {
        return (
            <div className="">
                <div className='timer-wrapper'>
                    <div className=''>
                        <CountdownCircleTimer
                            key={this.state.restartKey}
                            size={40}
                            trailColor='#1CEA24'
                            isPlaying={true}
                            duration={5}
                            colors={["#004777", "#F7B801", "#A30000", "#A30000"]}
                            colorsTime={[10, 6, 3, 0]}
                            onComplete={() => ({ shouldRepeat: false, delay: 1 }, this.allowKeyPress())}
                        >
                            {/* {(remainingTime) => (
                                                    <div className="d-flex flex-column justify-content-center align-items-center">
                                                        <div className="timer-text">
                                                            {this.children(remainingTime)}
                                                        </div>
                                                    </div>
                                                )} */}
                        </CountdownCircleTimer>
                    </div>
                </div>
            </div>
        )
    }


    handleStartListening = () => {
        const { isListening } = this.state;

        if (window.electron && window.electron.remoteControl) {
            if (isListening) {
                this.setState({ isListening: false });
                window.electron.remoteControl.unsubscribeEvents();
                window.electron.remoteControl.close();
            } else {
                this.setState({ isListening: true });
                console.log('Opening remote control', window.electron.remoteControl.open);
                window.electron.remoteControl.open();

                window.electron.remoteControl.subscribeEvents((data) => {
                    console.log('Received data:', data);

                    let studentList = this.state.studentList
                    console.log(studentList)

                    let index = studentList.findIndex(item => item.userDeviceMacId === data.payload.id)

                    console.log(index)

                    if (index != -1) {
                        if (studentList[index].isTeacher && data.payload.value === 8) {
                            this.toggleLayoutBar()

                        }

                        if (studentList[index].isTeacher && data.payload.value === 1) {

                            if (this.state.pageNumber >= this.state.numPages) {
                                console.log('last page next called')
                                this.props.delegate && this.props.delegate.hideRevisionFlow && this.props.delegate.hideRevisionFlow()
                            } else {
                                this.nextPage()
                            }
                        }

                        if (studentList[index].isTeacher && data.payload.value === 2) {
                            this.prevPage()
                        }

                        if (studentList[index].isTeacher && data.payload.value === 3) {
                            this.props.delegate && this.props.delegate.hideRevisionFlow && this.props.delegate.hideRevisionFlow()
                        }

                    } else if (this.props.isReadOnly) {
                    }

                });
            }
            window.electron.ipcRenderer.once('ipc-example', (arg) => {
                // eslint-disable-next-line no-console
                console.log(arg);
            });
            window.electron.ipcRenderer.send('ipc-example', ['ping']);
        }

        if (window.AndroidClicker) {
            // Set up the global function to receive click events from WebView
            window.onClickEvent = (event) => {
                console.log("Click Event Received:", event);

                // Ensure the event is parsed from JSON if necessary
                let clickData = typeof event === "string" ? JSON.parse(event) : event;

                clickData.value += 1

                console.log(clickData)

                let studentList = this.state.studentList

                let index = studentList.findIndex(item => item.userDeviceMacId === clickData.id)

                // console.log(index)

                if (index != -1) {

                    const now = Date.now();
                    let key = `${clickData.id}_${clickData.value}`

                    if (studentList[index].isTeacher &&
                        studentList[index][key]) {
                        // console.log('with Key')
                        let isValid = Math.floor((now - studentList[index][key].timestamp) / 1000) > 5 // In Seconds

                        if (clickData.value === 1 && isValid) {
                            // console.log('Valid Next')
                            studentList[index][key].timestamp = now
                            if (this.state.pageNumber >= this.state.numPages && this.state.allowKey) {
                                console.log('last page next called')
                                this.props.delegate && this.props.delegate.hideRevisionFlow && this.props.delegate.hideRevisionFlow()
                            } else if(this.state.allowKey) {
                                this.nextPage()
                            }
                        }

                        if (clickData.value === 2 && isValid && this.state.allowKey) {
                            this.prevPage()
                        }

                        if (clickData.value === 3 && isValid) {
                            this.props.delegate && this.props.delegate.hideRevisionFlow && this.props.delegate.hideRevisionFlow()
                        }

                        if (clickData.value === 8 && isValid) {
                            this.toggleLayoutBar()
                        }


                    } else if (studentList[index].isTeacher &&
                        !studentList[index][key]) {
                        // console.log('no key')

                        let obj = {
                            value: clickData.value,
                            timestamp: now,
                            receiveTeacherInput: true
                        }

                        studentList[index][key] = obj

                        if (clickData.value === 1 && this.state.allowKey) {
                            if (this.state.pageNumber >= this.state.numPages) {
                                console.log('last page next called')
                                this.props.delegate && this.props.delegate.hideRevisionFlow && this.props.delegate.hideRevisionFlow()
                            } else if(this.state.allowKey){
                                this.nextPage()
                            }
                        }

                        if (clickData.value === 2 && this.state.allowKey) {
                            this.prevPage()
                        }

                        if (clickData.value === 3) {
                            this.props.delegate && this.props.delegate.hideRevisionFlow && this.props.delegate.hideRevisionFlow()
                        }

                        if (studentList[index].isTeacher && clickData.value === 8) {
                            this.toggleLayoutBar()
                        }

                    }

                } else if (this.props.isReadOnly) {
                }


                // Update the component state with new click event data
                // this.setState({ clickData });
            };
        }


    };

    componentWillUnmount() {
        // Cleanup on component unmount
        console.log('component unmounted')
        if (window.electron && window.electron.remoteControl) {
            window.electron.remoteControl.unsubscribeEvents();
            window.electron.remoteControl.close();
        }

        if (window.AndroidClicker) {
            this.stopScanning()
        }

        window.removeEventListener("resize", this.handleResize);

    }

    closePdfFlow() {
        this.props.delegate && this.props.delegate.hideRevisionFlow && this.props.delegate.hideRevisionFlow()
    }


    render() {

        const { pageNumber, numPages } = this.state;

        return (

            <div className="clicker-revision-experience"
                ref={this.containerRef}
                style={{
                    width: "100%",
                    textAlign: "center"
                }}
            >
                {
                    this.state.isLoading ?
                        <Loading />
                        :
                        <div className="position-relative">
                            <div className="position-absolute close-icon-wrapper">
                                <div className="d-flex align-items-center">
                                    {this.getTimer()}
                                    <div className="ml-3">
                                        <img className="close-icon cursor-pointer"
                                    onClick={() => this.closePdfFlow()}
                                    src={getImageSource(ImageConstants.COUNTRY_CLOSE_ICON)} />
                                    </div>
                                </div>
                            
                                
                            </div>
                            
                            <canvas ref={this.canvasRef}></canvas>

                            {/* <div style={{ marginTop: 20 }}>

                                <button onClick={this.prevPage}>
                                    Previous
                                </button>

                                <span style={{ margin: "0 20px" }}>
                                    Page {pageNumber} / {numPages}
                                </span>

                                <button onClick={this.nextPage}>
                                    Next
                                </button>

                            </div> */}
                        </div>
                }



            </div>

        );
    }
}

export default ClickerRevisionExperience;